import {CurrencyHelper} from "../../utils/CurrencyHelper";

export const COST_METRIC_NAME = 'Cost';
export const CLICKS_METRIC_NAME = 'Clicks';
export const CONVERSIONS_METRIC_NAME = 'Conversions';
export const IMPRESSIONS_METRIC_NAME = 'Impressions';
export const CPC_METRIC_NAME = 'CPC';
export const CTR_METRIC_NAME = 'CTR';
export const CPM_METRIC_NAME = 'CPM';
export const CPA_METRIC_NAME = 'CPA';
export const PURCHASES_VALUE_METRIC_NAME = 'Purchase Value';
export const ROAS_METRIC_NAME = 'ROAS';
export const ACOS_METRIC_NAME = 'ACOS';
export const CONVERSION_RATE_METRIC_NAME = 'Conversion Rate';

export const GA4_SESSIONS_METRIC_NAME = "Sessions (GA4)";
export const GA4_ACTIVE_USERS_METRIC_NAME = "Active Users (GA4)";
export const GA4_CONVERSIONS_METRIC_NAME = "Conversions (GA4)";
export const GA4_ECOMMERCE_PURCHASES_METRIC_NAME = "Ecommerce purchases (GA4)";
export const GA4_PURCHASE_REVENUE_METRIC_NAME = "Purchase Revenue (GA4)";
export const GA4_ROAS_METRIC_NAME = "ROAS (GA4)";
export const GA4_ACOS_METRIC_NAME = "ACOS (GA4)";
export const GA4_CPA_METRIC_NAME = "CPA (GA4)";

// Meta (Facebook/Instagram) live-api metrics. Son fetchadas on-demand desde Meta
// Insights en SyncDashboard y cacheadas en LiveApiMetric (no pasan por BigQuery).
export const META_REACH_METRIC_NAME = "Reach (Meta)";
export const META_FREQUENCY_METRIC_NAME = "Frequency (Meta)";
export const META_VIDEO_VIEW_METRIC_NAME = "Meta_Video_view";
export const META_VIDEO_VIEW_3S_METRIC_NAME = "Meta_Video_view_3s";
export const META_VIDEO_VIEW_3S_RATE_METRIC_NAME = "Meta_Video_view_3s_rate";
// ThruPlay: reproducciones de video completas o de al menos 15 segundos
// (campo video_thruplay_watched_actions). Distintas de Meta_Video_view (3 seg).
export const META_THRUPLAY_METRIC_NAME = "Meta_ThruPlay";
export const META_COST_PER_THRUPLAY_METRIC_NAME = "Meta_Cost_per_thruplay";
export const META_IG_NEW_FOLLOWERS_METRIC_NAME = "Meta_IG_new_followers";
export const META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME = "Meta_Cost_per_IG_new_follower";
export const META_IG_PROFILE_VISITS_METRIC_NAME = "Meta_IG_profile_visits";
export const META_POST_REACTION_METRIC_NAME = "Meta_Post_reaction";
export const META_COMMENT_METRIC_NAME = "Meta_Comment";
export const META_CLICK_TO_CALL_METRIC_NAME = "Meta_Click_to_call";
export const META_LIKE_METRIC_NAME = "Meta_Like";
export const META_COST_PER_LIKE_METRIC_NAME = "Meta_Cost_per_like";
export const META_COST_PER_IG_PROFILE_VISIT_METRIC_NAME = "Meta_Cost_per_IG_profile_visit";

// Top 4 conversiones "Populares" de Meta Ads + sus cost-per (pedido Pablo 2026-05-27).
// Expuestas como columnas built-in del dashboard via FIXED_META_METRICS (backend).
export const META_PIXEL_PURCHASE_METRIC_NAME = "Meta_Pixel_purchase";
export const META_COST_PER_PIXEL_PURCHASE_METRIC_NAME = "Meta_Cost_per_pixel_purchase";
export const META_PIXEL_LEAD_METRIC_NAME = "Meta_Pixel_lead";
export const META_COST_PER_PIXEL_LEAD_METRIC_NAME = "Meta_Cost_per_pixel_lead";
export const META_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME = "Meta_Messaging_conversation_started_7d";
export const META_COST_PER_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME = "Meta_Cost_per_messaging_conversation_started_7d";
export const META_LEAD_METRIC_NAME = "Meta_Lead";
export const META_COST_PER_LEAD_METRIC_NAME = "Meta_Cost_per_lead";
// "Lead forms" = onsite_conversion.lead_grouped ("Clientes potenciales en Facebook"), pedido Pablo 2026-05-29.
export const META_ONSITE_LEAD_METRIC_NAME = "Meta_Onsite_lead";
export const META_COST_PER_ONSITE_LEAD_METRIC_NAME = "Meta_Cost_per_onsite_lead";

// Google Ads live-api metrics. Solo existen a nivel campaign en Google Ads API.
// Las 5 search-IS solo para campañas SEARCH; las 3 video (quartile rate, views, CPV)
// solo para VIDEO. video_views es aditiva; las otras 7 son ratios precomputados.
export const GOOGLE_SEARCH_IS_METRIC_NAME = "Search Impression Share (Google)";
export const GOOGLE_SEARCH_TOP_IS_METRIC_NAME = "Top Impression Share (Google)";
export const GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME = "Absolute Top Impression Share (Google)";
export const GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME = "Search Lost Impression Share - Rank (Google)";
export const GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME = "Search Lost Impression Share - Budget (Google)";
export const GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME = "Video Quartile 25% Rate (Google)";
export const GOOGLE_VIDEO_VIEWS_METRIC_NAME = "Video Views (Google)";
export const GOOGLE_CPV_METRIC_NAME = "CPV (Google)";
// Interactions: count aditivo cross-canal (suma de clicks + views + engagements
// + llamadas según el tipo de campaña). Google la agrega bien sin filtro.
export const GOOGLE_INTERACTIONS_METRIC_NAME = "Interactions (Google)";

// TikTok Ads live-api metrics. No persisten a BigQuery; resueltas por TiktokLiveApiProvider.
// Display names "3s"/"15s" son alias semánticos: TikTok mide en thresholds de 2s/6s (los más
// cercanos disponibles a los thresholds 3s/15s que reporta Meta).
export const TIKTOK_REACH_METRIC_NAME = "Reach (TikTok)";
export const TIKTOK_FREQUENCY_METRIC_NAME = "Frequency (TikTok)";
export const TIKTOK_VIDEO_VIEWS_METRIC_NAME = "Video Views (TikTok)";
export const TIKTOK_VIDEO_VIEW_2S_METRIC_NAME = "Video View 3s (TikTok)";
export const TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME = "Video View 3s Rate (TikTok)";
export const TIKTOK_FOLLOWS_METRIC_NAME = "New Followers (TikTok)";
export const TIKTOK_COST_PER_FOLLOW_METRIC_NAME = "Cost per Follower (TikTok)";
export const TIKTOK_PROFILE_VISITS_METRIC_NAME = "Profile Visits (TikTok)";
export const TIKTOK_COST_PER_PROFILE_VISIT_METRIC_NAME = "Cost per Profile Visit (TikTok)";
export const TIKTOK_LIKES_METRIC_NAME = "Likes (TikTok)";
export const TIKTOK_COMMENTS_METRIC_NAME = "Comments (TikTok)";
export const TIKTOK_VIDEO_VIEW_6S_METRIC_NAME = "Video View 15s (TikTok)";
export const TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME = "Video View 15s Rate (TikTok)";

// LinkedIn Ads en vivo (card AxXYBhPm). No persisten: las resuelve LinkedinLiveApiProvider. No son
// columnas fijas: se ofrecen en el selector de métricas (columnas propias y objetivos).
export const LINKEDIN_VIDEO_VIEWS_METRIC_NAME = "Video Views (LinkedIn)";
export const LINKEDIN_VIDEO_COMPLETIONS_METRIC_NAME = "Video Completions (LinkedIn)";
export const LINKEDIN_TOTAL_ENGAGEMENTS_METRIC_NAME = "Total Engagements (LinkedIn)";
export const LINKEDIN_REACTIONS_METRIC_NAME = "Reactions (LinkedIn)";
export const LINKEDIN_COMMENTS_METRIC_NAME = "Comments (LinkedIn)";
export const LINKEDIN_SHARES_METRIC_NAME = "Shares (LinkedIn)";
export const LINKEDIN_FOLLOWS_METRIC_NAME = "New Followers (LinkedIn)";
export const LINKEDIN_LEAD_FORM_LEADS_METRIC_NAME = "Lead Form Leads (LinkedIn)";
export const LINKEDIN_LEAD_FORM_OPENS_METRIC_NAME = "Lead Form Opens (LinkedIn)";

export const ECOMMERCE_SESSIONS_METRIC_NAME = "Sessions (Ecommerce)";
export const ECOMMERCE_GROSS_REVENUE_METRIC_NAME = "Gross Revenue (Ecommerce)";
export const ECOMMERCE_ORDERS_METRIC_NAME = "Orders (Ecommerce)";
export const ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME = "Avg Gross Order Value (Ecommerce)";
export const ECOMMERCE_ROAS_METRIC_NAME = "ROAS (Ecommerce)";
export const ECOMMERCE_ACOS_METRIC_NAME = "ACOS (Ecommerce)";
export const ECOMMERCE_CONVERTION_RATE_METRIC_NAME = "Conversion Rate (Ecommerce)";
export const ECOMMERCE_CPA_METRIC_NAME = "CPA (Ecommerce)";

// Métricas que pueden venir vacías porque la API no ofrece datos (ej: TiendaNube no levanta sesiones)
// o porque el dato no es atribuible a ese nivel (las de GA4 a nivel campaña: Analytics no siempre
// identifica de qué campaña vino una sesión — card eWizKIw6).
export const METRICS_WITH_POTENTIAL_EMPTY_VALUES = [
    ECOMMERCE_SESSIONS_METRIC_NAME,
    ECOMMERCE_CONVERTION_RATE_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME,
    GA4_ACTIVE_USERS_METRIC_NAME,
    GA4_CONVERSIONS_METRIC_NAME,
    GA4_ECOMMERCE_PURCHASES_METRIC_NAME,
    GA4_PURCHASE_REVENUE_METRIC_NAME,
    GA4_ROAS_METRIC_NAME,
    GA4_ACOS_METRIC_NAME,
    GA4_CPA_METRIC_NAME
];

// Mapeo de métricas a claves de traducción para mensajes específicos cuando están vacías
export const EMPTY_METRIC_VALUE_TOOLTIP_KEYS = {
    [ECOMMERCE_SESSIONS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ecommerce_sessions',
    [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ecommerce_conversion_rate',
    // Las ocho de GA4 comparten mensaje: la razón de que la celda esté vacía es la misma para
    // todas, y repetir el texto por métrica sólo agrega ocho lugares donde puede desincronizarse.
    [GA4_SESSIONS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_ACTIVE_USERS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_CONVERSIONS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_ECOMMERCE_PURCHASES_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_PURCHASE_REVENUE_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_ROAS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_ACOS_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4',
    [GA4_CPA_METRIC_NAME]: 'dashboard.empty_metric_value_tooltip.ga4'
};

export const META_METRICS = [
    META_REACH_METRIC_NAME, META_FREQUENCY_METRIC_NAME, META_VIDEO_VIEW_METRIC_NAME,
    META_THRUPLAY_METRIC_NAME, META_COST_PER_THRUPLAY_METRIC_NAME,
    META_VIDEO_VIEW_3S_METRIC_NAME, META_VIDEO_VIEW_3S_RATE_METRIC_NAME,
    META_IG_NEW_FOLLOWERS_METRIC_NAME, META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME,
    META_IG_PROFILE_VISITS_METRIC_NAME, META_COST_PER_IG_PROFILE_VISIT_METRIC_NAME,
    META_POST_REACTION_METRIC_NAME,
    META_COMMENT_METRIC_NAME, META_CLICK_TO_CALL_METRIC_NAME,
    META_LIKE_METRIC_NAME, META_COST_PER_LIKE_METRIC_NAME,
    META_PIXEL_PURCHASE_METRIC_NAME, META_COST_PER_PIXEL_PURCHASE_METRIC_NAME,
    META_PIXEL_LEAD_METRIC_NAME, META_COST_PER_PIXEL_LEAD_METRIC_NAME,
    META_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME, META_COST_PER_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME,
    META_LEAD_METRIC_NAME, META_COST_PER_LEAD_METRIC_NAME,
    META_ONSITE_LEAD_METRIC_NAME, META_COST_PER_ONSITE_LEAD_METRIC_NAME,
];

export const GOOGLE_METRICS = [
    GOOGLE_SEARCH_IS_METRIC_NAME, GOOGLE_SEARCH_TOP_IS_METRIC_NAME, GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME,
    GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME, GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME,
    GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME, GOOGLE_VIDEO_VIEWS_METRIC_NAME, GOOGLE_CPV_METRIC_NAME,
    GOOGLE_INTERACTIONS_METRIC_NAME,
];

export const TIKTOK_METRICS = [
    TIKTOK_REACH_METRIC_NAME, TIKTOK_FREQUENCY_METRIC_NAME, TIKTOK_VIDEO_VIEWS_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_2S_METRIC_NAME, TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME,
    TIKTOK_FOLLOWS_METRIC_NAME, TIKTOK_COST_PER_FOLLOW_METRIC_NAME,
    TIKTOK_PROFILE_VISITS_METRIC_NAME, TIKTOK_COST_PER_PROFILE_VISIT_METRIC_NAME,
    TIKTOK_LIKES_METRIC_NAME, TIKTOK_COMMENTS_METRIC_NAME,
    TIKTOK_VIDEO_VIEW_6S_METRIC_NAME, TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME,
];

export const LINKEDIN_METRICS = [
    LINKEDIN_VIDEO_VIEWS_METRIC_NAME, LINKEDIN_VIDEO_COMPLETIONS_METRIC_NAME,
    LINKEDIN_TOTAL_ENGAGEMENTS_METRIC_NAME, LINKEDIN_REACTIONS_METRIC_NAME,
    LINKEDIN_COMMENTS_METRIC_NAME, LINKEDIN_SHARES_METRIC_NAME, LINKEDIN_FOLLOWS_METRIC_NAME,
    LINKEDIN_LEAD_FORM_LEADS_METRIC_NAME, LINKEDIN_LEAD_FORM_OPENS_METRIC_NAME,
];

export const ALL_METRICS = [COST_METRIC_NAME, CLICKS_METRIC_NAME, CONVERSIONS_METRIC_NAME, IMPRESSIONS_METRIC_NAME,
    CPC_METRIC_NAME, CTR_METRIC_NAME, CPM_METRIC_NAME, CPA_METRIC_NAME, PURCHASES_VALUE_METRIC_NAME, ROAS_METRIC_NAME, ACOS_METRIC_NAME, CONVERSION_RATE_METRIC_NAME,
    GA4_SESSIONS_METRIC_NAME, GA4_ACTIVE_USERS_METRIC_NAME, GA4_CONVERSIONS_METRIC_NAME, GA4_ECOMMERCE_PURCHASES_METRIC_NAME,
    GA4_PURCHASE_REVENUE_METRIC_NAME, GA4_ROAS_METRIC_NAME, GA4_ACOS_METRIC_NAME, GA4_CPA_METRIC_NAME,
    ECOMMERCE_SESSIONS_METRIC_NAME, ECOMMERCE_GROSS_REVENUE_METRIC_NAME, ECOMMERCE_ORDERS_METRIC_NAME, ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME, ECOMMERCE_ROAS_METRIC_NAME,
    ECOMMERCE_ACOS_METRIC_NAME, ECOMMERCE_CONVERTION_RATE_METRIC_NAME, ECOMMERCE_CPA_METRIC_NAME,
    ...META_METRICS, ...GOOGLE_METRICS, ...TIKTOK_METRICS, ...LINKEDIN_METRICS];

export const HAS_ACTIONS_EXTRA_DATA = [CONVERSIONS_METRIC_NAME, CPA_METRIC_NAME, CONVERSION_RATE_METRIC_NAME];

export const METRIC_TYPE_CURRENCY = 'Currency'
export const METRIC_TYPE_INTEGER = 'Integer'
export const METRIC_TYPE_DECIMAL = 'Decimal'

export const PROPERTIES_FOR_METRIC = {
    [COST_METRIC_NAME]: {'Spanish':'Costo', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [CLICKS_METRIC_NAME]: {'Spanish':'Clicks', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [CONVERSIONS_METRIC_NAME]: {'Spanish':'Conversiones', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [IMPRESSIONS_METRIC_NAME]: {'Spanish':'Impresiones', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [CPC_METRIC_NAME]: {'Spanish':'CPC', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [CTR_METRIC_NAME]: {'Spanish':'CTR', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [CPM_METRIC_NAME]: {'Spanish':'CPM', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [CPA_METRIC_NAME]: {'Spanish':'CPA', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [PURCHASES_VALUE_METRIC_NAME]: {'Spanish':'Valor de Compra', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [ROAS_METRIC_NAME]: {'Spanish':'ROAS', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ACOS_METRIC_NAME]: {'Spanish':'ACOS', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [CONVERSION_RATE_METRIC_NAME]: {'Spanish':'Tasa de conversión', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_SESSIONS_METRIC_NAME]: {'Spanish':'Sesiones (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [GA4_ACTIVE_USERS_METRIC_NAME]: {'Spanish':'Usuarios (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [GA4_CONVERSIONS_METRIC_NAME]: {'Spanish':'Conversiones (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_ECOMMERCE_PURCHASES_METRIC_NAME]: {'Spanish':'Transacciones de ecommerce (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_PURCHASE_REVENUE_METRIC_NAME]: {'Spanish':'Ingresos (GA4)', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [GA4_ROAS_METRIC_NAME]: {'Spanish':'ROAS (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_ACOS_METRIC_NAME]: {'Spanish':'ACOS (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GA4_CPA_METRIC_NAME]: {'Spanish':'CPA (GA4)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_SESSIONS_METRIC_NAME]: {'Spanish':'Sesiones (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [ECOMMERCE_GROSS_REVENUE_METRIC_NAME]: {'Spanish':'Ventas Totales (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_ORDERS_METRIC_NAME]: {'Spanish':'Órdenes (Ecommerce)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [ECOMMERCE_AVG_GROSS_ORDER_VALUE_METRIC_NAME]: {'Spanish':'Valor promedio de orden (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [ECOMMERCE_ROAS_METRIC_NAME]: {'Spanish':'ROAS (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_ACOS_METRIC_NAME]: {'Spanish':'ACOS (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_CONVERTION_RATE_METRIC_NAME]: {'Spanish':'Tasa de conversión (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [ECOMMERCE_CPA_METRIC_NAME]: {'Spanish':'CPA (Ecommerce)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_REACH_METRIC_NAME]: {'Spanish':'Alcance', 'Accumulates': false, 'Type': METRIC_TYPE_INTEGER},
    [META_FREQUENCY_METRIC_NAME]: {'Spanish':'Frecuencia', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [META_VIDEO_VIEW_METRIC_NAME]: {'Spanish':'Reproducciones de video (3 segundos)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_THRUPLAY_METRIC_NAME]: {'Spanish':'Reproducciones de video (ThruPlay)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_THRUPLAY_METRIC_NAME]: {'Spanish':'Costo por ThruPlay', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_VIDEO_VIEW_3S_METRIC_NAME]: {'Spanish':'Video Views 3 segundos', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_VIDEO_VIEW_3S_RATE_METRIC_NAME]: {'Spanish':'% Video Views 3 segundos', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [META_IG_NEW_FOLLOWERS_METRIC_NAME]: {'Spanish':'Nuevos seguidores de Instagram', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_IG_NEW_FOLLOWER_METRIC_NAME]: {'Spanish':'Costo por seguidor de Instagram', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_IG_PROFILE_VISITS_METRIC_NAME]: {'Spanish':'Visitas al perfil de Instagram', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_IG_PROFILE_VISIT_METRIC_NAME]: {'Spanish':'Costo por visita al perfil de Instagram', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_POST_REACTION_METRIC_NAME]: {'Spanish':'Reacciones al post', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COMMENT_METRIC_NAME]: {'Spanish':'Comentarios', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_CLICK_TO_CALL_METRIC_NAME]: {'Spanish':'Llamadas realizadas', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_LIKE_METRIC_NAME]: {'Spanish':'Me gusta de Facebook', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_LIKE_METRIC_NAME]: {'Spanish':'Costo por Me gusta', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_PIXEL_PURCHASE_METRIC_NAME]: {'Spanish':'Compras (Pixel)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_PIXEL_PURCHASE_METRIC_NAME]: {'Spanish':'Costo por compra (Pixel)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_PIXEL_LEAD_METRIC_NAME]: {'Spanish':'Clientes potenciales (Pixel)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_PIXEL_LEAD_METRIC_NAME]: {'Spanish':'Costo por cliente potencial (Pixel)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME]: {'Spanish':'Conversaciones de mensajería iniciadas (7d)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_MESSAGING_CONVERSATION_STARTED_7D_METRIC_NAME]: {'Spanish':'Costo por conversación de mensajería iniciada (7d)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_LEAD_METRIC_NAME]: {'Spanish':'Todos los clientes potenciales (Meta)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_LEAD_METRIC_NAME]: {'Spanish':'Costo por cliente potencial (Meta)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [META_ONSITE_LEAD_METRIC_NAME]: {'Spanish':'Lead forms (Meta)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [META_COST_PER_ONSITE_LEAD_METRIC_NAME]: {'Spanish':'Costo por lead form (Meta)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [GOOGLE_SEARCH_IS_METRIC_NAME]: {'Spanish':'Cuota de impr. de búsqueda', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_SEARCH_TOP_IS_METRIC_NAME]: {'Spanish':'% de impr. (parte sup.)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_SEARCH_ABS_TOP_IS_METRIC_NAME]: {'Spanish':'% de impr. (parte sup. abs.)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_SEARCH_LOST_IS_RANK_METRIC_NAME]: {'Spanish':'Cuota impr. perd. de búsq. (ranking)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_SEARCH_LOST_IS_BUDGET_METRIC_NAME]: {'Spanish':'% impr. perdidas de búsq. (presup.)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_VIDEO_QUARTILE_P25_RATE_METRIC_NAME]: {'Spanish':'% video views al 25%', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [GOOGLE_VIDEO_VIEWS_METRIC_NAME]: {'Spanish':'Visualizaciones de Trueview', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [GOOGLE_CPV_METRIC_NAME]: {'Spanish':'CPV de Trueview', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [GOOGLE_INTERACTIONS_METRIC_NAME]: {'Spanish':'Participaciones', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    // Display Spanish con sufijo "(TikTok)" para evitar colisión con Meta en dropdowns
    // de Goals / Flex Indicators. Mismo patrón que GA4 / Ecommerce.
    [TIKTOK_REACH_METRIC_NAME]: {'Spanish':'Alcance (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_FREQUENCY_METRIC_NAME]: {'Spanish':'Frecuencia (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [TIKTOK_VIDEO_VIEWS_METRIC_NAME]: {'Spanish':'Reproducciones de video (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_VIDEO_VIEW_2S_METRIC_NAME]: {'Spanish':'Video Views 3 segundos (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_VIDEO_VIEW_2S_RATE_METRIC_NAME]: {'Spanish':'% Video Views 3 segundos (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    [TIKTOK_FOLLOWS_METRIC_NAME]: {'Spanish':'Nuevos seguidores (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_COST_PER_FOLLOW_METRIC_NAME]: {'Spanish':'Costo por seguidor (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [TIKTOK_PROFILE_VISITS_METRIC_NAME]: {'Spanish':'Visitas al perfil (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_COST_PER_PROFILE_VISIT_METRIC_NAME]: {'Spanish':'Costo por visita al perfil (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_CURRENCY},
    [TIKTOK_LIKES_METRIC_NAME]: {'Spanish':'Me gusta (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_COMMENTS_METRIC_NAME]: {'Spanish':'Comentarios (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_VIDEO_VIEW_6S_METRIC_NAME]: {'Spanish':'Video Views 15 segundos (TikTok)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [TIKTOK_VIDEO_VIEW_6S_RATE_METRIC_NAME]: {'Spanish':'% Video Views 15 segundos / Hold Rate (TikTok)', 'Accumulates': false, 'Type': METRIC_TYPE_DECIMAL},
    // Mismo criterio que TikTok: sufijo "(LinkedIn)" en el nombre. Las nueve son conteos aditivos.
    [LINKEDIN_VIDEO_VIEWS_METRIC_NAME]: {'Spanish':'Reproducciones de video (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_VIDEO_COMPLETIONS_METRIC_NAME]: {'Spanish':'Reproducciones completas de video (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_TOTAL_ENGAGEMENTS_METRIC_NAME]: {'Spanish':'Interacciones totales (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_REACTIONS_METRIC_NAME]: {'Spanish':'Reacciones (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_COMMENTS_METRIC_NAME]: {'Spanish':'Comentarios (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_SHARES_METRIC_NAME]: {'Spanish':'Veces compartido (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_FOLLOWS_METRIC_NAME]: {'Spanish':'Nuevos seguidores (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_LEAD_FORM_LEADS_METRIC_NAME]: {'Spanish':'Leads de formularios nativos (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER},
    [LINKEDIN_LEAD_FORM_OPENS_METRIC_NAME]: {'Spanish':'Aperturas de formularios nativos (LinkedIn)', 'Accumulates': true, 'Type': METRIC_TYPE_INTEGER}
}

export const FORMAT_METRIC_VALUE = (metric_name, value) => {
    // Defensiva: AgencyCustomMetric usa keys `CUSTOM:<id>` que no están en
    // PROPERTIES_FOR_METRIC. También cubre métricas nuevas que el backend
    // ya devuelve pero el FE todavía no conoce (forward-compat). Sin esto,
    // el lookup undefined["Type"] tira TypeError y dispara el ErrorBoundary
    // (caso típico: BUSummaryRow en /client/<id>/ con goal sobre custom metric).
    const props = PROPERTIES_FOR_METRIC[metric_name];
    const type = props && props["Type"];
    if(type === METRIC_TYPE_CURRENCY)
        return CurrencyHelper.formatNumberToCurrency(value, true);
    else if(type === METRIC_TYPE_INTEGER)
        return value;
    else if(type === METRIC_TYPE_DECIMAL)
        return parseFloat(value).toLocaleString('en-US');

    // Fallback genérico: si es numérico, lo formateamos con separadores; sino
    // devolvemos el value as-is. Nunca tirar — el caller suele estar en un
    // render path (cells, tooltips) donde un crash inutiliza la pantalla.
    const asNumber = parseFloat(value);
    if (!isNaN(asNumber)) return asNumber.toLocaleString('en-US');
    return value;
};
